import { Link } from "react-router-dom";

// Landing page. Once chunk 6 wires /season/:teamId, this redirects authed captains
// straight to their season view; unauthed visitors stay here and click into /auth/request.
export default function Home() {
  return (
    <section>
      <h1>nofuzz captain web UI</h1>
      <p>
        Sign in to set up your team and run match week from your iMessage
        co-captain.
      </p>
      <p>
        <Link to="/auth/request" className="button">
          Sign in
        </Link>
      </p>
    </section>
  );
}
